export const mandatoryItems = [
  { id: 'context', title: 'Context', color: '#FFD700' },
  { id: 'title', title: 'Title', color: '#A3CEF1' },
  { id: 'url', title: 'URL', color: '#F9D5A7' },
  { id: 'content', title: 'Content', color: '#B6E2D3' },
  { id: 'pubdate', title: 'Publication Date', color: '#E2C2F0', hasCheckbox: true, checkboxLabel: 'Include Ingestion Date' },
];

export const optionalItems = [
  { id: 'summary', title: 'Summary', color: '#F6A6B2' },
  { id: 'citation', title: 'Citation', color: '#C2F0FC' },
  { id: 'category', title: 'Category', color: '#FFB74D' },
];

export const allItems = [...mandatoryItems, ...optionalItems]; 